import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiUrl } from "Services/Services";

function Banner() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [banners, setBanners] = useState([
    {
      id: 1,
      title: "Summer Sale",
      description: "Up to 50% off on all items",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSc36FQ7-a7S8_OrLeaSuEUos2IjaA2vP1UNQ&s",
    },
  ]);

  const [newBanner, setNewBanner] = useState({
    title: "",
    description: "",
    image: null,
    preview: null,
  });

 
   const fetchBanner = async() =>{
        try {
            const response = await axios.get(`${ApiUrl}/banner`);
            console.log(response);
            setBanners(response.data.data)
        } catch (error) {
            console.log(error.message)
        }
    }
     useEffect(()=>{
   
    fetchBanner()
  },[])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewBanner((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewBanner((prev) => ({
        ...prev,
        image: file,
        preview: URL.createObjectURL(file),
      }));
    }
  };

  const handleAddBanner = async() => {
      if (!newBanner.title || !newBanner.description || !newBanner.image) return;
      const formData = new FormData();
        formData.append("title", newBanner.title );
        formData.append("description", newBanner.description );
        formData.append("image", newBanner.image );
      try {
        const response = await axios.post(`${ApiUrl}/banner` , formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    setIsModalOpen(false)
    fetchBanner()
    
        console.log(response);

    } catch (error) {
        console.log(error.message)
    }

  };

  const handleDelete = async(id) => {
   try {
        const response = await axios.delete(`${ApiUrl}/banner/banners/${id}`)
        console.log(response);
        fetchBanner()
   } catch (error) {
    console.log(error.message)
   }
  };

  return (
    <div className="p-6">
      <div className="flex justify-end items-center mb-6">
        {/* <h1 className="text-2xl font-bold">Banners</h1> */}
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Add Banner
        </button>
      </div>

      {/* Banner List */}
      <div className="grid md:grid-cols-3 gap-4">
        {banners.map((banner) => (
          <div
            key={banner.id}
            className="bg-white rounded-lg overflow-hidden shadow-md"
          >
            <img
              src={banner.image}
              alt={banner.title}
              className="h-40 w-full object-cover"
            />
            <div className="p-4">
              <h2 className="font-semibold text-lg">{banner.title}</h2>
              <p className="text-sm text-gray-600">{banner.description}</p>
              <button
                onClick={() => handleDelete(banner.id)}
                className="mt-2 text-red-600 hover:underline text-sm"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white w-full max-w-lg rounded-xl p-6 shadow-lg relative">
            <h2 className="text-xl font-semibold mb-4">Add Banner</h2>
            <div className="space-y-4">
              <input
                name="title"
                placeholder="Title"
                value={newBanner.title}
                onChange={handleChange}
                className="w-full border border-gray-300 px-4 py-2 rounded-md"
              />
              <textarea
                name="description"
                placeholder="Description"
                value={newBanner.description}
                onChange={handleChange}
                className="w-full border border-gray-300 px-4 py-2 rounded-md"
              />
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="w-full"
              />
              {newBanner.preview && (
                <img
                  src={newBanner.preview}
                  alt="Preview"
                  className="h-32 w-full object-cover rounded-md"
                />
              )}
              <div className="flex justify-end gap-2 pt-2">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAddBanner}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Banner;
